import { defineStore } from "pinia";
import {
  collection,
  query,
  getFirestore,
  where,
  getDocs
} from "firebase/firestore";
import { userUserStore } from "../../stores/user";
import { ProductosRubro, productosRubroConverter } from "@fixeduy/fixedtypes";

export const useProductosRubrosStore = defineStore({
  id: "productosRubro",
  persist: true,
  state: () => {
    return {
      _rubros: [] as ProductosRubro[],
      _rubrosCuenta: 0 as number
    };
  },
  getters: {
    rubros(): ProductosRubro[] {
      return this._rubros;
    },
    getUltimoRubroEdicion(): number {
      let mayorFechaUltimaEdicion = 0;
      this._rubros.map(r => {
        if (r.ultimaEdicion > mayorFechaUltimaEdicion) {
          mayorFechaUltimaEdicion = r.ultimaEdicion;
        }
      });
      return mayorFechaUltimaEdicion;
    }
  },
  actions: {
    async getRubrosFromFirestore() {
      const db = getFirestore();
      const userStore = userUserStore();
      const collectionRoute = `empresas/${userStore.empresa?.id}/productos-rubros/`;
      const mayorFechaUltimaEdicion = this.getUltimoRubroEdicion;

      return new Promise<void>((resolve, reject) => {
        getDocs(
          query(
            collection(db, collectionRoute),
            where("ultimaEdicion", ">=", mayorFechaUltimaEdicion)
          ).withConverter(productosRubroConverter)
        ).then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.addRubroToStore(doc.data());
          });
          resolve();
        });
      });
    },
    addRubroToStore(rubro: ProductosRubro) {
      // reviso que no exista
      for (var i = 0; i < this._rubros.length; i++) {
        if (this._rubros[i].id == rubro.id) {
          this._rubros[i] = rubro;
          return; // corto ejecucion de la funcion
        }
      }

      // lo inserto y ordeno
      this._rubros.push(rubro);
      this._rubros.sort((a, b) =>
        b.nombreCompleto > a.nombreCompleto ? -1 : 1
      );
    },
    getRubroById(id: string): ProductosRubro | null {
      for (var i = 0; i < this._rubros.length; i++) {
        if (this._rubros[i].id == id) {
          return this._rubros[i];
        }
      }
      return null;
    },
    getRubroByUltimaEdicion(ultimaEdicion: number): ProductosRubro | null {
      for (var i = 0; i < this._rubros.length; i++) {
        if (this._rubros[i].ultimaEdicion == ultimaEdicion) {
          return this._rubros[i];
        }
      }

      return null;
    }
  }
});
